import Styled from 'styled-components';

import { ISelectInputProps, SelectInputStyle } from './SelectInputStyle';

// tslint:disable-next-line:max-line-length
const inputBackground: string = `"data:image/svg+xml;charset=utf8,%3Csvg width='11px' height='7px' viewBox='0 0 11 7' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdesc%3ESelect%3C/desc%3E%3Cdefs%3E%3Cpath d='M5.414,6.414 C5.158,6.414 4.902,6.316 4.707,6.121 L0,1.414 L1.414,0 L5.414,4 L9.414,0 L10.828,1.414 L6.121,6.121 C5.926,6.316 5.67,6.414 5.414,6.414 Z' id='path-1'%3E%3C/path%3E%3C/defs%3E%3Cg id='Symbols' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cmask id='mask-2' fill='white'%3E%3Cuse xlink:href='%23path-1'%3E%3C/use%3E%3C/mask%3E%3Cuse id='Mask' fill='%23444444' fill-rule='nonzero' xlink:href='%23path-1'%3E%3C/use%3E%3C/g%3E%3C/svg%3E"`;
// tslint:disable-next-line:max-line-length
const inputBackgroundHover: string = `"data:image/svg+xml;charset=utf8,%3Csvg width='11px' height='7px' viewBox='0 0 11 7' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdesc%3ESelect%3C/desc%3E%3Cdefs%3E%3Cpath d='M5.414,6.414 C5.158,6.414 4.902,6.316 4.707,6.121 L0,1.414 L1.414,0 L5.414,4 L9.414,0 L10.828,1.414 L6.121,6.121 C5.926,6.316 5.67,6.414 5.414,6.414 Z' id='path-1'%3E%3C/path%3E%3C/defs%3E%3Cg id='Symbols' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cmask id='mask-2' fill='white'%3E%3Cuse xlink:href='%23path-1'%3E%3C/use%3E%3C/mask%3E%3Cuse id='Mask' fill='%23038203' fill-rule='nonzero' xlink:href='%23path-1'%3E%3C/use%3E%3C/g%3E%3C/svg%3E"`;

export const SelectInput = Styled.select<ISelectInputProps>`
  ${SelectInputStyle}

  background-image: url(${inputBackground});
  background-size: auto 8px;
  border-width: 1px;
  transition: border-color ease-in-out 0.15s;

  &:hover,
  &:focus {
    border: 1px solid ${({ theme: { input } }) => input.colorBorder};
    border-bottom-width: 2px;
    border-bottom-color: ${({ theme: { brand } }) => brand.colorSecondary};
    background-image: url(${inputBackgroundHover});
  }
`;

SelectInput.displayName = 'SelectInput';

export default SelectInput;
